up.compiler('.form-check-input[data-on]', (element) => {
    element.addEventListener('change', () => {
        if (element.closest('[up-validate]')) {
            up.validate(element)
        }
    })
})
